// RenderUsers.jsx
import React, { useMemo } from "react";
import Loader from "../../components/Loader";

const fmtDate = (d) => {
    if (!d) return "—";
    try {
        return new Date(d).toLocaleString("ru-RU", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return "—";
    }
};

const COLUMNS = {
    users: [
        { key: "role", label: "Роль", render: (u) => u.role },
        { key: "firstName", label: "Имя", render: (u) => u.firstName },
        { key: "lastName", label: "Фамилия", render: (u) => u.lastName },
        { key: "email", label: "Email", render: (u) => u.email },
        { key: "createdAt", label: "Зарегистрирован", render: (u) => fmtDate(u.createdAt) },
    ],
    partners: [
        { key: "fio", label: "ФИО", render: (u) => `${u.firstName} ${u.lastName}`.trim() },
        { key: "email", label: "Email", render: (u) => u.email },
        { key: "phone", label: "Телефон", render: (u) => u.contactNumber || "—" },
        { key: "org", label: "Организация", render: (u) => u.nameOrganization || "—" },
        { key: "status", label: "Статус", render: () => <span className="listGrid__status">Партнёр</span> },
        { key: "createdAt", label: "Зарегистрирован", render: (u) => fmtDate(u.createdAt) },
    ],
};


const CARD_FIELDS = {
    users: [
        { label: "Роль", render: (u) => u.role },
        { label: "Имя", render: (u) => u.firstName },
        { label: "Фамилия", render: (u) => u.lastName },
        { label: "Email", render: (u) => u.email },
    ],
    partners: [
        { label: "ФИО", render: (u) => `${u.firstName} ${u.lastName}`.trim() },
        { label: "Email", render: (u) => u.email },
        { label: "Телефон", render: (u) => u.contactNumber || "—" },
        { label: "Организация", render: (u) => u.nameOrganization || "—" },
    ],
};


const CARD_FOOTER = {
    users: (u) => ({ left: u.role, right: fmtDate(u.createdAt) }),
    partners: (u) => ({ left: "Партнёр", right: fmtDate(u.createdAt) }),
};

const RenderUsers = ({
    users = [],
    variant = "users",
    showUserDetailsModal,
    onOpen,
    loading = false,
    pageNumber = 0,
    pageSize = 12,
}) => {
    const open = onOpen || showUserDetailsModal;
    const columns = useMemo(() => COLUMNS[variant] || COLUMNS.users, [variant]);
    const cardFields = useMemo(() => CARD_FIELDS[variant] || CARD_FIELDS.users, [variant]);
    const cardFooter = CARD_FOOTER[variant] || CARD_FOOTER.users;
    const baseIndex = (Number(pageNumber) || 0) * (Number(pageSize) || 0);

    if (loading) return <Loader />;
    if (!users || users.length === 0) {
        return <div className="listGrid__empty">Ничего не найдено.</div>;
    }

    return (
        <div className="listGrid">
            <div className="listGrid__tableWrap">
                <table className="listGrid__table">
                    <thead>
                        <tr>
                            <th>#</th>
                            {columns.map((c) => (
                                <th key={c.key}>{c.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((u, idx) => (
                            <tr
                                key={u._id || idx}
                                onClick={() => open && open(u._id, "details")}
                                style={{ cursor: "pointer" }}
                            >
                                <td>{baseIndex + idx + 1}</td>
                                {columns.map((c) => (
                                    <td key={c.key}>{c.render(u)}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="listGrid__cards">
                {users.map((u, idx) => {
                    const footer = cardFooter(u);
                    return (
                        <div
                            className="listCard"
                            key={u._id || idx}
                            onClick={() => open && open(u._id, "details")}
                            role="button"
                        >
                            {cardFields.map((f, i) => (
                                <div className="listCard__line" key={i}>
                                    <span className="listCard__label">{f.label}:</span>
                                    <span className="listCard__value">{f.render(u)}</span>
                                </div>
                            ))}
                            <div className="listCard__footer">
                                <span className="listCard__status">{footer.left}</span>
                                <span className="listCard__date">{footer.right}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RenderUsers;